module.exports = __webpack_public_path__ + "static/img/WechatIMG152.bda3dcac.jpeg";